import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';

export default function MyTeachersPage() {
  const [relations, setRelations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadRelations();
  }, []);

  async function loadRelations() {
    setLoading(true);
    setError('');
    try {
      const res = await api.get('/auth/teacher-student-relations/');
      const data = Array.isArray(res.data) ? res.data : res.data?.results ?? [];
      setRelations(data);
    } catch (e) {
      setError(e.response?.data?.detail || 'Не удалось загрузить список преподавателей.');
    } finally {
      setLoading(false);
    }
  }

  const teacherRelations = relations.filter((r) => r.student_username && r.teacher_username);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="my-teachers-page">
      <div className="page-header">
        <h1>Мои преподаватели</h1>
        <p className="page-subtitle">
          Список преподавателей, с которыми у вас есть связь на сайте.{' '}
          <Link to="/topic-progress">Мой прогресс по темам</Link>
          {' — заметки преподавателей о прогрессе.'}
        </p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {teacherRelations.length === 0 ? (
        <p className="text-secondary">Пока нет активных связей с преподавателями.</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Преподаватель</th>
              <th>Статус связи</th>
              <th>Когда обновлено</th>
            </tr>
          </thead>
          <tbody>
            {teacherRelations.map((rel) => (
              <tr key={rel.id}>
                <td>{rel.teacher_username}</td>
                <td>{rel.status}</td>
                <td>
                  {rel.updated_at
                    ? new Date(rel.updated_at).toLocaleString('ru-RU')
                    : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

